import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function StyleModal({
  isOpen,
  onClose,
  title,
  description,
  options = [],
  selectedOption,
  onSelect,
}) {
  const handleSelect = (option) => {
    if (!option.disabled) {
      onSelect(option);
      onClose();
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[100]" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all max-h-[80vh] flex flex-col">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 flex justify-between items-center"
                >
                  {title}
                  <button
                    onClick={onClose}
                    className="rounded-full p-1 hover:bg-gray-100"
                  >
                    <XMarkIcon className="h-5 w-5 text-gray-500" />
                  </button>
                </Dialog.Title>

                <div className="mt-2">
                  <p className="text-sm text-gray-500">{description}</p>
                </div>

                <div className="mt-4 overflow-y-auto pr-1">
                  <div className="grid grid-cols-1 gap-4">
                    {options.map((option) => (
                      <button
                        key={option.id}
                        onClick={() => handleSelect(option)}
                        className={`p-4 rounded-lg border ${
                          selectedOption?.id === option.id
                            ? "border-blue-500 bg-blue-50"
                            : option.disabled
                            ? "border-gray-200 bg-gray-50 cursor-not-allowed opacity-60"
                            : "border-gray-200 hover:border-blue-300"
                        }`}
                        disabled={option.disabled}
                      >
                        <div className="flex items-center space-x-8">
                          <img
                            src={option.image}
                            alt={option.title}
                            className="w-16 h-16 object-cover rounded border-2 border-gray-700 shadow-md"
                          />
                          <div className="flex-1 text-left">
                            <h3 className="font-medium text-gray-900">
                              {option.displayTitle || option.title}
                            </h3>
                            <p className="text-sm text-gray-500">
                              {option.description}
                            </p>
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
